module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Dual Lands","path":"/badlands"}}}]}},"pathContext":{"tag":"Card Review"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-card-review.json
// module id = 433
// module chunks = 142166431648673